<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="380">
    <v-card>
        <v-toolbar dense class="mb-4" color="primary" dark>
            ADD FULL ITEM
           <v-spacer/>
           <v-icon @click="emitToParent('close')">mdi-close</v-icon>
        </v-toolbar>
        <v-card-text>
           <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <v-autocomplete
                  v-model="product"
                  label="Product code"
                    :rules="textRules"
                    required
                  dense
                  item-text="code"
                  return-object
                  outlined
                  :items="products"
                  class="mb-1"
                />
                 <v-text-field 
                    v-model="item.qty"
                    label="Quantity"
                    type="number"
                    :rules="textRules"
                    required
                    requir
                    dense
                    outlined
                />
           </v-form>
        </v-card-text>
         
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  small color="success" rounded depressed  @click="validate()"><v-icon small left>mdi-check</v-icon>ADD</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapMutations
} from 'vuex'
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    type: {
      type: String,
      default:''
    }
  },
  data: () => ({
    valid: true,
    product_list:[],
    item:{},
      product:{},
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
    products(){
        var items = this.$store.state.products.reduce((res,item)=>{
            
            if(item.type == this.type) { res.push(item) }
            return res
        },[])
        return items
    }
  },
  watch: {
    show(v) {
      if(!v) {
        this.item = {}
        this.product = {}
      }
    }
  },
  methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText']),
    emitToParent (action) {
        this.$emit('DialogEvent',action)
    },
  validate () {
        if (this.$refs.form.validate()) {
            this.item.code = this.product.code
            this.item.type=this.type
            this.item.unit_price = this.product.price_per_unit
            this.item.qty = parseInt(this.item.qty)
            this.item.amount = (this.$IsNum(this.product.price_per_unit) * this.$IsNum(this.item.qty)).toString()
            this.$emit('DialogEvent',this.item)
        }
      }
  }
}
</script>
